import { render, staticRenderFns } from "./majorCourseAdd.vue?vue&type=template&id=3e1e8d10&scoped=true&"
import script from "./majorCourseAdd.vue?vue&type=script&lang=js&"
export * from "./majorCourseAdd.vue?vue&type=script&lang=js&"
import style0 from "./majorCourseAdd.vue?vue&type=style&index=0&id=3e1e8d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e8d10",
  null
  
)

export default component.exports